// extracted by mini-css-extract-plugin
export default {"container":"container-eX424","header":"header-vCfOa","divider":"divider-UoRnX","body":"body-MOYJL","listContainer":"listContainer-kJyhJ"};